import React, {useState, useEffect} from 'react';
import {Box} from '@mui/material';
import PropTypes from 'prop-types';
import RichEditorResultText from './Shared/RichEditorResultText';
import RichEditor from './Shared/RichEditor';
import RequiredCheckbox from './Shared/RequiredCheckbox';
import AdmicityAddressLookup from '../../../../../shared-components/AdmicityAddressLookup';
import {stripHtmlTags} from './AdditionalNotes';

const Address = ({
                     index,
                     id,
                     value,
                     onChange,
                     description,
                     isEditMode,
                     enableValidation,
                     isFormArchived,
                     accessLevel,
                     readonly,
                     placeholderValues,
                     error,
                     audience,
                     recipientType,
                 }) => {
    const [currentValue, setCurrentValue] = useState(description ?? '');

    useEffect(() => {
        setCurrentValue(description ?? '');
    }, [description]);

    const handleDescriptionChange = (nextValue) => {
        setCurrentValue(nextValue);

        if (!onChange) return;

        onChange({
            index,
            description: stripHtmlTags(nextValue),
            formattedDescription: nextValue,
        });
    };

    const handleAddressSelect = (address) => {
        onChange({
            id,
            value: address
        });
    };

    const renderEditMode = () => (
        <Box>
            <RichEditor
                value={description}
                onChange={onChange}
                id={id}
                index={index}
                isEditMode={isEditMode}
                isFormLive={isFormArchived}
                accessLevel={accessLevel}
                currentDescription={currentValue}
                setCurrentDescription={handleDescriptionChange}
                audience={audience}
                recipientType={recipientType}
            />
            <RequiredCheckbox
                enableValidation={enableValidation}
                index={index}
                onChange={onChange}
                isFormArchived={isFormArchived}
            />
        </Box>
    );

    const renderViewMode = () => (
        <>
            <RichEditorResultText
                id={id}
                description={description}
                placeholderValues={placeholderValues}
                readonly={readonly}
                enableValidation={enableValidation}
            />
            <Box mt={2}>
                <AdmicityAddressLookup
                    onAddressSelect={handleAddressSelect}
                    readonly={readonly}
                    initialValue={value}
                    defaultCountry={process.env.REACT_APP_DEFAULT_COUNTRY}
                    errors={error}
                    enableValidation={enableValidation}
                />
            </Box>
        </>
    );

    return <Box sx={{mt: 2}}>{isEditMode ? renderEditMode() : renderViewMode()}</Box>;
};

Address.propTypes = {
    id: PropTypes.string,
    value: PropTypes.object,
    index: PropTypes.number,
    description: PropTypes.string,
    enableValidation: PropTypes.bool,
    onChange: PropTypes.func,
    isEditMode: PropTypes.bool,
    isFormArchived: PropTypes.bool,
    readonly: PropTypes.bool,
    accessLevel: PropTypes.number,
    placeholderValues: PropTypes.object,
    error: PropTypes.object,
    audience: PropTypes.number,
    recipientType: PropTypes.string,
};

export default Address;
